import useSWRImmutable from "swr/immutable";
import authAxios from "../../helpers/authAxios";
import { Assignee, AssigneeType, remoteProjectAssignee } from "../Task/api";

export type Teams = {
  _id: string;
  name: string;
};

export type Roles = {
  _id: string;
  role_name: string;
};

export type Designation = {
  _id: string;
  name: string;
};

export type Profile = {
  _id: string;
  first_name: string;
  last_name: string;
  email_id: string;
};

export type Department = {
  _id: string;
  name: string;
  manager: { _id: string; name: string; profilepic: string };
};

export type TeamList = {
  _id: string;
  name: string;
  description: string;
  work_schedule: string;
  manager: { _id: string; name: string; profilepic: string };
};

export type Employees = {
  _id: string;
  profilepic: string;
  profilepic_key: string;
  name: string;
  designation: Teams;
  // reporting_to: {_id: string, name: string, profilepic: string};
  reporting_to: any;
  reporting_to_profilepic: string;
  email_id: string;
  role: Roles;
  training_video: any;
  training_video_key: string;
  employee_number: string;
  phonenumber: string;
};

export type TeamForm = {
  _id?: string;
  name: string;
  manager?: string | null;
  description: string | null;
  work_schedule: string | null;
};

export type EmployeeForm = {
  _id?: string;
  profilepic?: string;
  first_name: string;
  last_name: string;
  training_video: string;
  role: string;
  designation: string;
  department: string;
  reporting_to: any;
  type: string;
  skype_id: string;
  date_of_birth: string;
  date_of_joining: string;
  email_id: string;
  personal_emailId: string;
  linkedIn_id: string;
  bank_details: string;
  pan_number: string;
  aadhar_number: string;
  phonenumber: string;
  alternative_phonenumber: string;
  address: string;
  isactive_user: boolean;
  gender: string;
  father_name: string;
  mother_name: string;
  marital_status: string;
  esi_number: string;
  uan_number: string;
  employee_number: string;
  casual_leave: string;
  sick_leave: string;
  privileged_leave: string ;
  total_leave_allocated: string;
  total_leave_approved: string;
};

export type EmployeeType = {
  name: string;
  email_id: string;
  uan_number: string;
  esi_number: string;
  marital_status: string;
  mother_name: string;
  father_name: string;
  gender: string;
  _id: string;
  profilepic?: string;
  profile: {
    training_video: string;
    first_name: string;
    last_name: string;
    email_id: string;
    isactive_user: boolean;
  };
  role: { _id: string; role_name: string };
  designation: { _id: string; name: string };
  department: { _id: string; name: string };
  reporting_to: { _id: string; name: string; profilepic: string };
  type: string;
  skype_id: string;
  date_of_birth: string;
  date_of_joining: string;
  phonenumber: string;
  alternative_phonenumber: string;
  address: string;
  personal_emailId: string;
  linkedIn_id: string;
  bank_details: string;
  pan_number: string;
  aadhar_number: string;
  employee_number: string;
    casual_leave: string;
    sick_leave: string;
    privileged_leave: string;
    total_leave_allocated: string;
    total_leave_approved: string;
  
};

type ResponseState = {
  isLoading: boolean;
  isError: boolean;
};

// type SWRTeamList = ResponseState & {
//     teamsList: TeamList[]
// }

type SWRRolesList = ResponseState & {
  rolesList: Roles[] | undefined;
};

type SWRDesignationList = ResponseState & {
  designationList: Designation[] | undefined;
};

// type SWREmployeeList = ResponseState & {
//     employeesList: Employees[] | []
// }

export type remoteTeamAssignee = {
  training_video_key: string;
  _id: string;
  profilepic: string;
  profilepic_key: string;
  profile: {
    _id: string;
    first_name: string;
    last_name: string;
    email_id: string;
  };
  designation: Teams;
  department: Department;
  role: Roles;
  reporting_to: { _id: string; name: string; profilepic: string };
  phonenumber: string;
};

export class Employee {
  private data;
  constructor(data: remoteTeamAssignee) {
    this.data = data;
  }

  get training_video_key() {
    return this.data.training_video_key;
  }

  get name() {
    return `${this.data.profile.first_name} ${this.data.profile.last_name}`;
  }

  get profilepic() {
    return this.data.profilepic;
  }

  get designation() {
    return `${this.data.designation?.name}`;
  }

  get reporting_to() {
    return `${this.data.reporting_to ? this.data.reporting_to.name : ""}`;
  }

  get reporting_to_profilepic() {
    return `${this.data.reporting_to?.profilepic}`;
  }

  get phonenumber() {
    return `${this.data.phonenumber}`;
  }

  get email_id() {
    return this.data.profile.email_id;
  }

  get profilepic_key() {
    return this.data.profilepic_key;
  }

  get role() {
    return this.data.role.role_name;
  }

  get _id() {
    return this.data._id;
  }
}

const getTeamsList = (url: string): Promise<TeamList[]> =>
  authAxios.get(url).then((resp): TeamList[] => {
    const result = resp.data?.result;
    return result;
  });

const getTeamDetails = (url: string): Promise<TeamList> =>
  authAxios.get(url).then((resp): TeamList => {
    const result = resp.data;
    return result;
  });

const getRoles = (url: string): Promise<Roles[]> =>
  authAxios.get(url).then((resp): Roles[] => {
    const result = resp.data?.result;
    return result;
  });

const getDesignation = (url: string): Promise<Designation[]> =>
  authAxios.get(url).then((resp): Designation[] => {
    const result = resp.data?.data;
    return result;
  });

const getEmployeeList = (url: string): Promise<Employees[]> =>
  authAxios.get(url).then((resp) => {
    const assignees = resp.data?.data;
    return assignees.map((person: remoteTeamAssignee) => new Employee(person));
  });

const getEmployeeNumber = (url: string) =>
  authAxios.get(url).then((resp) => {
    const result = resp.data?.data;
    return result;
  });

const getEmployeeDetails = (url: string): Promise<EmployeeType> =>
  authAxios.get(url).then((resp) => {
    const result = resp.data?.data;
    return result;
  });

export const createTeam = (formData: TeamForm) =>
  authAxios.post("/departments", formData).then((resp) => resp.data);

export const updateTeam = (teamId: string, formData: TeamForm) =>
  authAxios.put(`/departments/${teamId}`, formData);

export const deleteEmployee = (employeeId: string) =>
  authAxios.delete(`/employees/${employeeId}`);

export const deleteEmployeeTrainingVideo = (employeeId: string) =>
  authAxios.delete(`/employees/trainingvideo/${employeeId}`);

export const deleteTeam = (teamId: string) =>
  authAxios.delete(`/departments/${teamId}`);

export const deleteTask = (taskId: string) =>
  authAxios.delete(`/tasks/${taskId}`);

export const updateEmployee = (employeeId: string, formData: EmployeeForm) =>
  authAxios.put(`/employees/${employeeId}`, formData);

export const updateTrainingVideo = (employeeId: string, formData: any) =>
  authAxios.put(`/employees/trainingvideo/${employeeId}`, formData);

export const createEmployee = (formData: any) =>
  authAxios.post("/employees", formData).then((resp) => resp.data);

//export const createTrainingQueueVideo = (formData: Employees) => authAxios.post('/employees', formData).then( resp => resp.data )

export const getImageFileUrl = (formData: any) =>
  authAxios
    .post("/attachments/files/single", formData)
    .then((resp) => resp.data);

//export const getVideoFileUrl = (formData: any) => authAxios.post('/attachments/files/single', formData).then(resp => resp.data )

const getAssignees = (url: string): Promise<AssigneeType[]> =>
  authAxios.get(url).then((resp) => {
    const assignees = resp.data?.data;
    return assignees;
    // return assignees.map( (person: remoteProjectAssignee) => new Assignee(person) )
  });

export const useTeamsList = () => {
  const { data, error, mutate } = useSWRImmutable(
    "/departments/list",
    getTeamsList
  );

  return {
    teamsList: data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
};

export const useRolesList = (): SWRRolesList => {
  const { data, error } = useSWRImmutable("/roles", getRoles);
  return {
    rolesList: data,
    isLoading: !error && !data,
    isError: error,
  };
};

export const useDesignationList = (): SWRDesignationList => {
  const { data, error } = useSWRImmutable(
    "/employees/designation",
    getDesignation
  );
  return {
    designationList: data,
    isLoading: !error && !data,
    isError: error,
  };
};

export const useEmployeeNumber = () => {
  const { data, error } = useSWRImmutable("/employees", getEmployeeNumber);
  return {
    employeeNumber: data,
    isLoading: !error && !data,
    isError: error,
  };
};

export const useEmployeeList = (teamId: string, roleId: string) => {
  const { data, error, mutate } = useSWRImmutable(
    `/departments/${teamId}/${roleId}`,
    getEmployeeList
  );

  return {
    employeesList: data || [],
    isEmployeesLoading: !error && !data,
    isEmployeesError: error,
    employeeListMutate: mutate,
  };
};

export const useEmployeeDetails = (employeeId: string) => {
  const { data, error, mutate } = useSWRImmutable(
    employeeId ? `/employees/${employeeId}` : null,
    getEmployeeDetails
  );
  return {
    employeeDetails: data,
    isEmpDataLoading: !error && !data,
    isError: error,
    employeeDataMutate: mutate,
  };
};

export const useAssigneeList = () => {
  const { data, error } = useSWRImmutable(
    `/departments/employees/list`,
    getAssignees
  );
  return {
    assignees: data || [],
    isLoading: !error && !data,
    isError: error,
  };
};

export const useTeamDetails = (teamId: string) => {
  const { data, error, mutate } = useSWRImmutable(
    `/departments/${teamId}`,
    getTeamDetails
  );
  return {
    teamsDetails: data,
    isLoading: !error && !data,
    isError: error,
    teamMutate: mutate,
  };
};
